import { RuntimeException1r3t0zl97011n as RuntimeException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { firstOrNull1982767dljvdy as firstOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ApolloExceptionClass;
function ApolloException() {
  if (ApolloExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static y4f(message, cause) {
        message = message === VOID ? null : message;
        cause = cause === VOID ? null : cause;
        var $this = this.wd(message, cause);
        captureStack($this, $this.x4f_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloException');
    ApolloExceptionClass = $;
  }
  return ApolloExceptionClass;
}
var ApolloOfflineExceptionClass;
function ApolloOfflineException() {
  if (ApolloOfflineExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor() {
        return new.target.d4g();
      }
      static d4g() {
        var $this = this.y4f('The device is offline');
        captureStack($this, $this.c4g_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloOfflineException', $.d4g);
    ApolloOfflineExceptionClass = $;
  }
  return ApolloOfflineExceptionClass;
}
var ApolloNetworkExceptionClass;
function ApolloNetworkException() {
  if (ApolloNetworkExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(message, platformCause) {
        return new.target.r49(message, platformCause);
      }
      static r49(message, platformCause) {
        message = message === VOID ? null : message;
        platformCause = platformCause === VOID ? null : platformCause;
        var $this = this.y4f(message, platformCause instanceof Error ? platformCause : null);
        captureStack($this, $this.q49_1);
        $this.p49_1 = platformCause;
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloNetworkException', $.r49);
    ApolloNetworkExceptionClass = $;
  }
  return ApolloNetworkExceptionClass;
}
var ApolloWebSocketClosedExceptionClass;
function ApolloWebSocketClosedException() {
  if (ApolloWebSocketClosedExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(code, reason, cause) {
        return new.target.k4g(code, reason, cause);
      }
      static k4g(code, reason, cause) {
        reason = reason === VOID ? null : reason;
        cause = cause === VOID ? null : cause;
        var $this = this.y4f("WebSocket Closed code='" + code + "' reason='" + reason + "'", cause);
        captureStack($this, $this.j4g_1);
        $this.h4g_1 = code;
        $this.i4g_1 = reason;
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloWebSocketClosedException');
    ApolloWebSocketClosedExceptionClass = $;
  }
  return ApolloWebSocketClosedExceptionClass;
}
var ApolloGraphQLExceptionClass;
function ApolloGraphQLException() {
  if (ApolloGraphQLExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(error) {
        return new.target.k45(error);
      }
      static k45(error) {
        var $this = this.y4f("GraphQL error: '" + error.w48_1 + "'");
        captureStack($this, $this.j45_1);
        $this.h45_1 = error;
        $this.i45_1 = listOf($this.h45_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloGraphQLException');
    ApolloGraphQLExceptionClass = $;
  }
  return ApolloGraphQLExceptionClass;
}
var DefaultApolloExceptionClass;
function DefaultApolloException() {
  if (DefaultApolloExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(message, cause) {
        return new.target.d45(message, cause);
      }
      static d45(message, cause) {
        message = message === VOID ? null : message;
        cause = cause === VOID ? null : cause;
        var $this = this.y4f(message, cause);
        captureStack($this, $this.c45_1);
        return $this;
      }
    }
    initMetadataForClass($, 'DefaultApolloException', $.d45);
    DefaultApolloExceptionClass = $;
  }
  return DefaultApolloExceptionClass;
}
var NoDataExceptionClass;
function NoDataException() {
  if (NoDataExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(cause) {
        return new.target.q45(cause);
      }
      static q45(cause) {
        var $this = this.y4f('No data was found', cause);
        captureStack($this, $this.p45_1);
        return $this;
      }
    }
    initMetadataForClass($, 'NoDataException');
    NoDataExceptionClass = $;
  }
  return NoDataExceptionClass;
}
var JsonDataExceptionClass;
function JsonDataException() {
  if (JsonDataExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(message) {
        return new.target.l49(message);
      }
      static l49(message) {
        var $this = this.y4f(message);
        captureStack($this, $this.k49_1);
        return $this;
      }
    }
    initMetadataForClass($, 'JsonDataException');
    JsonDataExceptionClass = $;
  }
  return JsonDataExceptionClass;
}
var JsonEncodingExceptionClass;
function JsonEncodingException() {
  if (JsonEncodingExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(message) {
        return new.target.c4f(message);
      }
      static c4f(message) {
        var $this = this.y4f(message);
        captureStack($this, $this.b4f_1);
        return $this;
      }
    }
    initMetadataForClass($, 'JsonEncodingException');
    JsonEncodingExceptionClass = $;
  }
  return JsonEncodingExceptionClass;
}
var ApolloHttpExceptionClass;
function ApolloHttpException() {
  if (ApolloHttpExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(statusCode, headers, body, message, cause) {
        return new.target.s4g(statusCode, headers, body, message, cause);
      }
      static s4g(statusCode, headers, body, message, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.y4f(message, cause);
        captureStack($this, $this.r4g_1);
        $this.o4g_1 = statusCode;
        $this.p4g_1 = headers;
        $this.q4g_1 = body;
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloHttpException');
    ApolloHttpExceptionClass = $;
  }
  return ApolloHttpExceptionClass;
}
var RouterErrorClass;
function RouterError() {
  if (RouterErrorClass === VOID) {
    class $ extends ApolloException() {
      constructor(errors) {
        return new.target.y4g(errors);
      }
      static y4g(errors) {
        var tmp0_safe_receiver = firstOrNull(errors);
        var $this = this.y4f("Router error(s) (first: '" + (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w48_1) + "')");
        captureStack($this, $this.x4g_1);
        $this.w4g_1 = errors;
        return $this;
      }
    }
    initMetadataForClass($, 'RouterError');
    RouterErrorClass = $;
  }
  return RouterErrorClass;
}
var SubscriptionOperationExceptionClass;
function SubscriptionOperationException() {
  if (SubscriptionOperationExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(operationName, payload) {
        return new.target.e4h(operationName, payload);
      }
      static e4h(operationName, payload) {
        var $this = this.y4f('Operation error ' + operationName);
        captureStack($this, $this.d4h_1);
        $this.c4h_1 = payload;
        return $this;
      }
    }
    initMetadataForClass($, 'SubscriptionOperationException');
    SubscriptionOperationExceptionClass = $;
  }
  return SubscriptionOperationExceptionClass;
}
var SubscriptionConnectionExceptionClass;
function SubscriptionConnectionException() {
  if (SubscriptionConnectionExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(payload) {
        return new.target.k4h(payload);
      }
      static k4h(payload) {
        var $this = this.y4f('Subscription connection error');
        captureStack($this, $this.j4h_1);
        $this.i4h_1 = payload;
        return $this;
      }
    }
    initMetadataForClass($, 'SubscriptionConnectionException');
    SubscriptionConnectionExceptionClass = $;
  }
  return SubscriptionConnectionExceptionClass;
}
var NullOrMissingFieldClass;
function NullOrMissingField() {
  if (NullOrMissingFieldClass === VOID) {
    class $ extends ApolloException() {
      constructor(message) {
        return new.target.v45(message);
      }
      static v45(message) {
        var $this = this.y4f(message);
        captureStack($this, $this.u45_1);
        return $this;
      }
    }
    initMetadataForClass($, 'NullOrMissingField');
    NullOrMissingFieldClass = $;
  }
  return NullOrMissingFieldClass;
}
//region block: exports
export {
  ApolloException as ApolloException16lek20l78zc3,
  ApolloGraphQLException as ApolloGraphQLException2qazyzs4ebcad,
  ApolloHttpException as ApolloHttpException3o30u8ntkffuh,
  ApolloNetworkException as ApolloNetworkException3denf70pfh242,
  ApolloOfflineException as ApolloOfflineException3onq1f2zlyouj,
  ApolloWebSocketClosedException as ApolloWebSocketClosedException26hvn543pf46i,
  DefaultApolloException as DefaultApolloException8w3ielfxng0h,
  JsonDataException as JsonDataException2rdtm884tky1l,
  JsonEncodingException as JsonEncodingException1gbe1fu68vssf,
  NoDataException as NoDataException34qvcinicy2ih,
  NullOrMissingField as NullOrMissingField1bkks6typ2v8h,
  RouterError as RouterError3i6hxcnqsy5l3,
  SubscriptionConnectionException as SubscriptionConnectionException12fjxvnnqzby5,
  SubscriptionOperationException as SubscriptionOperationException3t8cqqpx8bt9j,
};
//endregion

//# sourceMappingURL=Exceptions.mjs.map
